import React, { useEffect, useState } from "react";
import Button from "../../../../components/ui/Button";
import Select from "../../../../components/ui/Select";
import api from "../../../../api/axiosInstance";
const QuickStartSection = ({ onQuickStart }) => {
  const [roles, setRoles] = useState([]);
  const [selectedRoleId, setSelectedRoleId] = useState("");
  const [selectedRole, setSelectedRole] = useState(null);

  const [selectedTechStack, setSelectedTechStack] = useState([]);
  const [experience, setExperience] = useState("");

  const [isEditingJD, setIsEditingJD] = useState(false);
  const [customJD, setCustomJD] = useState("");

  const [resumeFile, setResumeFile] = useState(null);
  const [hasResume, setHasResume] = useState(false);

  // 🔥 Load roles from backend
  useEffect(() => {
   api.get("/api/roles")
      .then(res => setRoles(res.data))
      .catch(err => console.error(err));
    // Check if user already uploaded resume
    const resumeFlag = localStorage.getItem("resumeUploaded");
    setHasResume(Boolean(resumeFlag));
  }, []);

  // 🔥 When role changes → populate JD + tech stack
  useEffect(() => {
    if (!selectedRoleId) return;

    const role = roles.find(r => r._id === selectedRoleId);
    setSelectedRole(role);
    setSelectedTechStack(role?.techStackOptions || []);
    setCustomJD(role?.defaultJD || "");
  }, [selectedRoleId, roles]);

  // 🔥 Toggle tech stack
  const handleTechToggle = (tech) => {
    setSelectedTechStack(prev =>
      prev.includes(tech)
        ? prev.filter(t => t !== tech)
        : [...prev, tech]
    );
  };

  // 🔥 Start Interview
  const handleStart = () => {
    if (!selectedRole) return alert("Please select a position");
    if (!experience) return alert("Please select experience level");

    onQuickStart({
      roleId: selectedRole._id,
      position: selectedRole.name,
      jobDescription: customJD,
      techStack: selectedTechStack,
      experience,
      resumeFile
    });
  };

  return (
    <div className="bg-white border rounded-xl p-8 shadow-sm space-y-6">

      {/* 🔹 Position Dropdown */}
      <Select
        label="Select Position"
        options={roles.map(r => ({
          value: r._id,
          label: r.name
        }))}
        value={selectedRoleId}
        onChange={setSelectedRoleId}
      />

      {/* 🔹 JD Section */}
      {selectedRole && (
        <div className="bg-gray-50 p-4 rounded-lg space-y-3">
          <div className="flex justify-between items-center">
            <strong>Job Description</strong>
            <button
              type="button"
              onClick={() => setIsEditingJD(prev => !prev)}
              className="text-blue-600 text-sm"
            >
              {isEditingJD ? "Cancel" : "Edit"}
            </button>
          </div>

          {isEditingJD ? (
            <textarea
              value={customJD}
              onChange={(e) => setCustomJD(e.target.value)}
              className="w-full border rounded p-2"
              rows={6}
            />
          ) : (
            <p className="text-sm text-gray-600 whitespace-pre-line">
              {customJD}
            </p>
          )}
        </div>
      )}

      {/* 🔹 Tech Stack Multi Select */}
      {selectedRole && (
        <div>
          <label className="block mb-2 font-medium">
            Select Tech Stack
          </label>

          <div className="flex flex-wrap gap-2">
            {selectedRole.techStackOptions.map((tech) => (
              <button
                key={tech}
                type="button"
                onClick={() => handleTechToggle(tech)}
                className={`px-3 py-1 rounded-full border text-sm transition ${
                  selectedTechStack.includes(tech)
                    ? "bg-blue-600 text-white"
                    : "bg-white hover:bg-gray-100"
                }`}
              >
                {tech}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* 🔹 Experience Dropdown (UI Only) */}
      {selectedRole && (
        <Select
          label="Experience Level"
          options={[
            { value: "0-1", label: "0–1 Years" },
            { value: "1-3", label: "1–3 Years" },
            { value: "3-5", label: "3–5 Years" },
            { value: "5+", label: "5+ Years" }
          ]}
          value={experience}
          onChange={setExperience}
        />
      )}

      {/* 🔹 Resume Upload (Only if user doesn't already have one) */}
      {!hasResume && (
        <div>
          <label className="block mb-2 font-medium">
            Upload Resume (Optional)
          </label>
          <input
            type="file"
            accept=".pdf"
            onChange={(e) => setResumeFile(e.target.files[0])}
            className="border p-2 rounded w-full"
          />
        </div>
      )}

      {/* 🔹 Start Button */}
      <Button onClick={handleStart} fullWidth>
        Start Interview
      </Button>

    </div>
  );
};

export default QuickStartSection;
